(ns lupapalvelu.ui2.icons
  "Wrapper ns for Carbon Icons.

  These should be preferred for new views over Lupicons.

  Any icons required here are included in the JS bundle, so we avoid
  requiring icons that aren't used."
  (:refer-clojure :exclude [filter])
  (:require ["@carbon/icons-react/es/Add$default" :as Add]
            ["@carbon/icons-react/es/Apps$default" :as Apps]
            ["@carbon/icons-react/es/Archive$default" :as Archive]
            ["@carbon/icons-react/es/ArrowDownRight$default" :as ArrowDownRight]
            ["@carbon/icons-react/es/ArrowLeft$default" :as ArrowLeft]
            ["@carbon/icons-react/es/ArrowRight$default" :as ArrowRight]
            ["@carbon/icons-react/es/ArrowUp$default" :as ArrowUp]
            ["@carbon/icons-react/es/Chat$default" :as Chat]
            ["@carbon/icons-react/es/ChevronDown$default" :as ChevronDown]
            ["@carbon/icons-react/es/ChevronLeft$default" :as ChevronLeft]
            ["@carbon/icons-react/es/ChevronRight$default" :as ChevronRight]
            ["@carbon/icons-react/es/ChevronUp$default" :as ChevronUp]
            ["@carbon/icons-react/es/Close$default" :as Close]
            ["@carbon/icons-react/es/Copy$default" :as Copy]
            ["@carbon/icons-react/es/CopyFile$default" :as CopyFile]
            ["@carbon/icons-react/es/DocumentMultiple_01$default" :as DocumentMultiple]
            ["@carbon/icons-react/es/Draggable$default" :as Draggable]
            ["@carbon/icons-react/es/DragVertical$default" :as DragVertical]
            ["@carbon/icons-react/es/Filter$default" :as Filter]
            ["@carbon/icons-react/es/Home$default" :as Home]
            ["@carbon/icons-react/es/Launch$default" :as Launch]
            ["@carbon/icons-react/es/Logout$default" :as Logout]
            ["@carbon/icons-react/es/Misuse$default" :as Misuse]
            ["@carbon/icons-react/es/OverflowMenuVertical$default" :as OverflowMenuVertical]
            ["@carbon/icons-react/es/Printer$default" :as Printer]
            ["@carbon/icons-react/es/Search$default" :as Search]
            ["@carbon/icons-react/es/Settings$default" :as Settings]
            ["@carbon/icons-react/es/SettingsAdjust$default" :as SettingsAdjust]
            ["@carbon/icons-react/es/ShoppingCart$default" :as ShoppingCart]
            ["@carbon/icons-react/es/TaskComplete$default" :as TaskComplete]
            ["@carbon/icons-react/es/TreeView$default" :as TreeView]
            ["@carbon/icons-react/es/Upload$default" :as Upload]
            ["@carbon/icons-react/es/User$default" :as User]
            [reagent.core :as r]))

(def add (r/adapt-react-class Add))
(def apps (r/adapt-react-class Apps))
(def archive (r/adapt-react-class Archive))
(def arrow-up (r/adapt-react-class ArrowUp))
(def arrow-left (r/adapt-react-class ArrowLeft))
(def arrow-right (r/adapt-react-class ArrowRight))
(def arrow-down-right (r/adapt-react-class ArrowDownRight))
(def chat (r/adapt-react-class Chat))
(def chevron-down (r/adapt-react-class ChevronDown))
(def chevron-left (r/adapt-react-class ChevronLeft))
(def chevron-right (r/adapt-react-class ChevronRight))
(def chevron-up (r/adapt-react-class ChevronUp))
(def close (r/adapt-react-class Close))
(def copy (r/adapt-react-class Copy))
(def copy-file (r/adapt-react-class CopyFile))
(def document-multiple (r/adapt-react-class DocumentMultiple))
(def drag-vertical (r/adapt-react-class DragVertical))
(def draggable (r/adapt-react-class Draggable))
(def filter (r/adapt-react-class Filter))
(def home (r/adapt-react-class Home))
(def launch (r/adapt-react-class Launch))
(def logout (r/adapt-react-class Logout))
(def misuse (r/adapt-react-class Misuse))
(def overflow-menu-vertical (r/adapt-react-class OverflowMenuVertical))
(def printer (r/adapt-react-class Printer))
(def search (r/adapt-react-class Search))
(def settings (r/adapt-react-class Settings))
(def settings-adjust (r/adapt-react-class SettingsAdjust))
(def shopping-cart (r/adapt-react-class ShoppingCart))
(def task-complete (r/adapt-react-class TaskComplete))
(def tree-view (r/adapt-react-class TreeView))
(def upload (r/adapt-react-class Upload))
(def user (r/adapt-react-class User))
